import { createPostHogAdapter } from './posthog-adapter';
import { createNoopAdapter } from './noop-adapter';

let adapter = null;

export const analytics = {
  init({ apiKey, ...options } = {}) {
    adapter = apiKey
      ? createPostHogAdapter(apiKey, options)
      : createNoopAdapter();
  },

  identify(userId, traits = {}) {
    adapter?.identify(userId, traits);
  },

  track(event, properties = {}) {
    adapter?.track(event, properties);
  },

  reset() {
    adapter?.reset();
  }
};
